
import './App.css';

import Navbar from './Component/Navbar';
import Post from './Pages/Post';
import AllRoute from './Routes/AllRoutes';




function App() {
  return (
    <div className="App">
      <Navbar/>
      <AllRoute/>
    </div>
  );
}

export default App;